import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type PgHeaderStatusBack = string|{ url: string, text?: string }

export class PgHeaderStatus {
    name?:string;
    subName?:string;
    appName?:string;
    logo?:string;
    color?:string;
    back?:PgHeaderStatusBack;
    backOnLogo?:boolean;
    hidden?:boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PgHeaderStatusService {
    constructor() {}

    status:PgHeaderStatus = {};

    statusChange = new Subject<PgHeaderStatus>()

    setStatus(status:PgHeaderStatus) {
        this.status = status;
        this.statusChange.next(this.status)
    }
}
